<template>
<div class="booking-transport">
    <div style="margin-top: 3px; height: 310px">
        <LoadingDataError v-if="loadingError.isError" :ErrorCode="loadingError.errorCode" />

        <DataTable
            :value="transportBooking"
            responsiveLayout="scroll"
            scrollHeight="280px"
            v-model:selection="selectedTransportBooking" 
            selectionMode="single"
            dataKey="id"
            v-if="!loadingError.isError"
        >
            <!-- <Column field="id" header="ID" :style="{'min-width':'30px'}"></Column> -->
            <Column field="company_name" header="Company" :style="{'min-width':'130px'}"></Column>
            <Column field="province" header="City" :style="{'min-width':'130px'}"></Column>
            <Column field="from_date" header="From" :style="{'min-width':'105px'}">
                <template #body="{data}">
                    {{data.from_date != null ? dayjs(data.from_date).format('DD-MMM-YYYY') : ''}}
                </template>
            </Column>
            <Column field="to_date" header="To" :style="{'min-width':'105px'}">
                <template #body="{data}">
                    {{data.from_date != null ? dayjs(data.from_date).format('DD-MMM-YYYY') : ''}}
                </template>
            </Column>
            <Column field="driver_name" header="Driver" :style="{'min-width':'120px'}"></Column>
            <Column field="phone" header="Contact" :style="{'min-width':'120px'}"></Column>

            <Column :exportable="false" :style="{'min-width':'75px', 'width':'75px', 'padding':'0.4rem 0rem', 'text-align':'right'}">
                <template #body="slotProps">
                    <Button v-if="can('update', 'booking')" icon="pi pi-pencil" class="p-button-rounded p-button-outlined p-button-success small-datatable-button p-mr-2" @click="onEditTransportBooking(slotProps.data)" />
                    <Button v-if="can('delete', 'booking')" icon="pi pi-trash" class="p-button-rounded p-button-outlined p-button-danger small-datatable-button p-mr-2" @click="confirmDeleteTransportBooking(slotProps.data)" />
                </template>
            </Column>
        </DataTable>
    </div>

    <hr style="border: 0; border-top: 1px solid var(--surface-d);"/>
    <div style="display: flex; align-self: flex-end; margin-bottom: 10px">
        <Button v-if="can('create', 'booking')" label="Add Transport Booking" class="p-button p-button-sm" @click="openBookingTransportForm()" :disabled="bookingID == 0 || loadingError.isError" />
        <Dialog v-model:visible="isBookingTransportFormShow" header="Transport Booking" :style="{width: '53rem', margin: '0px 5px'}" :modal="true">
            <BookingTransportForm ref="BookingTransportFormRef" :BookingID="bookingID" @RefreshTransportBooking="getTransportBooking" />
        </Dialog>
    </div>
</div>
</template>

<script>
import { ref, reactive, nextTick } from 'vue'
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import { useAbility } from '@casl/vue';
import BookingService from "../service/BookingService"
import LoadingDataError from '../components/LoadingDataError.vue';
import BookingTransportForm from '../components/BookingTransportForm.vue';
import dayjs from 'dayjs';

export default {
    setup() {
        const confirm = useConfirm();
        const toast = useToast();
        const { can } = useAbility();
        let transportBooking = ref([])
        let selectedTransportBooking = ref()
        let loadingError = reactive({isError: false, errorCode: ''})
        const isBookingTransportFormShow = ref(false)
        let bookingID = ref(0)
        const BookingTransportFormRef = ref()

        const bookingService = ref(new BookingService())

        //=============Method=============
        const getTransportBooking = (Booking_ID) => {
            if(Booking_ID != 0) {
                //SEND BOOKING_ID TO TRANSPORT BOOKING FORM'S PROPS
                bookingID.value = Booking_ID

                transportBooking.value.length = 0;
                selectedTransportBooking.value = null

                bookingService.value.getBookingTransport(Booking_ID).then(data => {
                    if(!data.errorResponse) {
                        transportBooking.value = data

                        loadingError.isError = false
                    } else {
                        loadingError.isError = true
                        loadingError.errorCode = data.status
                    }
                })
            }
        }

        const openBookingTransportForm = () => {
            isBookingTransportFormShow.value = true
        }

        const onEditTransportBooking = (data) => {
            selectedTransportBooking.value = data
            
            isBookingTransportFormShow.value = true
            nextTick(() => {
                BookingTransportFormRef.value.editTransportBooking(selectedTransportBooking.value)
            })
        }

        const confirmDeleteTransportBooking = (data) => {
            confirm.require({
                message: 'Are you sure you want to delete "'+ data.company_name + '" booking?',
                header: 'Delete Confirmation',
                icon: 'pi pi-info-circle',
                acceptClass: 'p-button-danger',
                accept: () => {
                    const bookingTransportID = data.id
                    bookingService.value.deleteBookingTransport(bookingTransportID).then((data) => {
                        if(!data.errorResponse){
                            transportBooking.value = transportBooking.value.filter(val => val.id !== bookingTransportID);
                        } else {
                            toast.add({severity:'warn', summary: 'Delete Error ' + data.status, detail: data.errorResponse, life: 4500});
                        }
                    })
                }
            });
        }

        return {
            can,
            loadingError,
            transportBooking,
            selectedTransportBooking,
            isBookingTransportFormShow,
            getTransportBooking,
            bookingID,

            openBookingTransportForm,
            BookingTransportFormRef,
            onEditTransportBooking,
            confirmDeleteTransportBooking,
            dayjs,
        }
    },
    components: {
        LoadingDataError,
        BookingTransportForm
    }
}
</script>

<style lang="scss" scoped>

</style>